import api from './api';

const supportInnovationApi = {
  getAll:          (params)        => api.get('/support-innovation', { params }),
  getById:         (id)            => api.get(`/support-innovation/${id}`),
  getNonLus:       ()              => api.get('/support-innovation/non-lus'),
  marquerVu:       (id)            => api.post(`/support-innovation/${id}/vu`),
  create:          (data)          => api.post('/support-innovation', data),
  update:          (id, data)      => api.put(`/support-innovation/${id}`, data),
  remove:          (id)            => api.delete(`/support-innovation/${id}`),
  getCommentaires: (id)            => api.get(`/support-innovation/${id}/commentaires`),
  addCommentaire:  (id, commentaire) => api.post(`/support-innovation/${id}/commentaires`, { commentaire }),
  updateCommentaire: (id, commentId, commentaire) => api.put(`/support-innovation/${id}/commentaires/${commentId}`, { commentaire }),
  generatePrompt:  (id, pageLabel)   => api.post(`/support-innovation/${id}/prompt`, { page_label: pageLabel }),
  groupPrompt:     (payload)         => api.post('/support-innovation/group-prompt', payload),
  checkScope:      (titre, type)     => api.post('/support-innovation/check-scope', { titre, type }),
  getLinks:        (id)              => api.get(`/support-innovation/${id}/links`),
  addLink:         (id, linkedId)    => api.post(`/support-innovation/${id}/links`, { linked_ticket_id: linkedId }),
  removeLink:      (id, linkedId)    => api.delete(`/support-innovation/${id}/links/${linkedId}`),
  setParent:       (id, parentId)    => api.patch(`/support-innovation/${id}/parent`, { parent_ticket_id: parentId }),
  getCommitRefs:   (id)              => api.get(`/support-innovation/${id}/commit-refs`),
};

export default supportInnovationApi;
